import { render, staticRenderFns } from "./SetupSectionNav.vue?vue&type=template&id=875fca3c&scoped=true"
import script from "./SetupSectionNav.vue?vue&type=script&lang=js"
export * from "./SetupSectionNav.vue?vue&type=script&lang=js"
import style0 from "./SetupSectionNav.vue?vue&type=style&index=0&id=875fca3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875fca3c",
  null
  
)

export default component.exports